@if (clickable()) {
    <button
        class="app-stack-icons app-stack-icons--clickable shrink-0"
        type="button"
        [matTooltip]="tooltip()"
        [matTooltipDisabled]="!tooltip()"
        (click)="onClick($event)">
        <ng-container *ngTemplateOutlet="icon" />
    </button>
} @else {
    <span
        class="app-stack-icons shrink-0"
        [matTooltip]="tooltip()"
        [matTooltipDisabled]="!tooltip()">
        <ng-container *ngTemplateOutlet="icon" />
    </span>
}

<ng-template #icon>
    <fa-layers [size]="size()">
        <fa-icon
            [class]="baseIconClass()"
            [icon]="baseIcon()"
            [transform]="baseIconTransform()" />
        <fa-icon
            [class]="topIconClass()"
            [icon]="topIcon()"
            [transform]="topIconTransform()" />
    </fa-layers>
</ng-template>
